module.exports = __webpack_public_path__ + "img/burger.20731753.svg";